import { render, staticRenderFns } from "./Trade.vue?vue&type=template&id=e33e4c4a&"
import script from "./Trade.vue?vue&type=script&lang=js&"
export * from "./Trade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports